module.exports = __webpack_public_path__ + "img/favicons/ape/android-chrome-192x192.png";